import {
  BriefcaseIcon,
  CircleCheckIcon,
  DocumentIcon,
  IdFrontIcon,
  LayersIcon,
  ListIcon,
  MergeIcon,
  UsersCheckIcon,
  WorkflowsIcon,
} from '@persona-id/design-tokens/icons/16px';

import { ApiModel } from 'lib/interfaces/api';

import { ShortcutSearchResult } from './OmnisearchModal';

export const NAVBAR_EXPANDED_WIDTH = 240;
export const NAVBAR_COLLAPSED_WIDTH = 64;

export const resourceIconMap: Partial<Record<ApiModel, React.FunctionComponent>> = {
  [ApiModel.Account]: UsersCheckIcon,
  [ApiModel.Case]: BriefcaseIcon,
  [ApiModel.CaseTemplate]: BriefcaseIcon,
  [ApiModel.Inquiry]: IdFrontIcon,
  [ApiModel.InquiryTemplate]: IdFrontIcon,
  [ApiModel.InquiryTemplateVersion]: IdFrontIcon,
  [ApiModel.List]: ListIcon,
  [ApiModel.Report]: DocumentIcon,
  [ApiModel.ReportTemplate]: DocumentIcon,
  [ApiModel.Transaction]: MergeIcon,
  [ApiModel.TransactionType]: MergeIcon,
  [ApiModel.Verification]: CircleCheckIcon,
  [ApiModel.VerificationTemplate]: CircleCheckIcon,
  [ApiModel.Webhook]: LayersIcon,
  [ApiModel.Workflow]: WorkflowsIcon,
  [ApiModel.WorkflowVersion]: WorkflowsIcon,
};

export const omnisearchShortcuts: ShortcutSearchResult[] = [
  {
    key: 'create-inquiry',
    label: 'Create an Inquiry',
    path: '/dashboard/inquiries?openCreateInquiryModal=true',
    segmentPath: '/dashboard/inquiries',
  },
  {
    key: 'create-inquiry-template',
    label: 'Create an Inquiry Template',
    path: '/dashboard/inquiry-templates?openCreateInquiryTemplateModal=true',
    segmentPath: '/dashboard/inquiry-templates',
  },
  {
    key: 'create-report',
    label: 'Create a Report',
    path: '/dashboard/reports?openCreateReportModal=true',
    segmentPath: '/dashboard/reports',
  },
  {
    key: 'create-case-template',
    label: 'Create a Case Template',
    path: '/dashboard/case-templates?openCreateCaseTemplateModal=true',
    segmentPath: '/dashboard/case-templates',
  },
  {
    key: 'create-account',
    label: 'Create an Account',
    path: '/dashboard/accounts?openCreateAccountModal=true',
    segmentPath: '/dashboard/accounts',
  },
  {
    key: 'create-workflow',
    label: 'Create a Workflow',
    path: '/dashboard/workflows?openCreateWorkflowModal=true',
    segmentPath: '/dashboard/workflows',
  },
  {
    key: 'create-list',
    label: 'Create a List',
    path: '/dashboard/lists?openAddListModal=true',
    segmentPath: '/dashboard/lists',
  },
  {
    key: 'create-transaction-type',
    label: 'Create a Transaction Type',
    path: '/dashboard/transaction-types?openCreateTransactionTypeModal=true',
    segmentPath: '/dashboard/transaction-types',
  },
  {
    key: 'create-api-key',
    label: 'Create an API Key',
    path: '/dashboard/api-keys?openCreateApiKeyModal=true',
    segmentPath: '/dashboard/api-keys',
  },
  {
    key: 'view-api-logs',
    label: 'View API Logs',
    path: '/dashboard/api-logs',
    segmentPath: '/dashboard/api-logs',
  },
  {
    key: 'create-webhook',
    label: 'Create a Webhook',
    path: '/dashboard/webhooks',
    segmentPath: '/dashboard/webhooks',
  },
  {
    key: 'view-webhook-events',
    label: 'View Webhook Events',
    path: '/dashboard/webhook-events',
    segmentPath: '/dashboard/webhook-events',
  },
  {
    key: 'create-role',
    label: 'Create a Role',
    path: '/dashboard/user-roles',
    segmentPath: '/dashboard/user-roles',
  },
  {
    key: 'invite-user',
    label: 'Invite a User',
    path: '/dashboard/users',
    segmentPath: '/dashboard/users',
  },
  {
    key: 'create-hubspot-connection',
    label: 'Create a Hubspot Connection',
    path: '/dashboard/marketplace/hubspot',
    segmentPath: '/dashboard/marketplace/hubspot',
  },
  {
    key: 'create-salesforce-connection',
    label: 'Create a Salesforce Connection',
    path: '/dashboard/marketplace/salesforce',
    segmentPath: '/dashboard/marketplace/salesforce',
  },
  {
    key: 'create-slack-connection',
    label: 'Create a Slack Connection',
    path: '/dashboard/marketplace/slack',
    segmentPath: '/dashboard/marketplace/slack',
  },
  {
    key: 'create-zendesk-connection',
    label: 'Create a Zendesk Connection',
    path: '/dashboard/marketplace/zendesk',
    segmentPath: '/dashboard/marketplace/zendesk',
  },
  {
    key: 'update-organization',
    label: 'Update my organization',
    path: '/dashboard/organization',
    segmentPath: '/dashboard/organization',
  },
  {
    key: 'update-profile',
    label: 'Update my profile',
    path: '/dashboard/user/profile',
    segmentPath: '/dashboard/user/profile',
  },
  {
    key: 'update-notifications',
    label: 'Update my notifications',
    path: '/dashboard/user/profile/notifications',
    segmentPath: '/dashboard/user/profile/notifications',
  },
  {
    key: 'update-password',
    label: 'Update my password',
    path: '/dashboard/user/profile/security',
    segmentPath: '/dashboard/user/profile/security',
  },
  {
    key: 'update-two-factor-authentication',
    label: 'Update my two-factor authentication',
    path: '/dashboard/user/profile/security',
    segmentPath: '/dashboard/user/profile/security',
  },
  {
    key: 'integration-guide',
    label: 'View the integration guide',
    path: '/dashboard/getting-started/overview',
    segmentPath: '/dashboard/getting-started/overview',
  },
  {
    key: 'integration-guide-hosted-flow',
    label: 'View the Hosted Flow integration guide',
    path: '/dashboard/getting-started/hosted-flow',
    segmentPath: '/dashboard/getting-started/hosted-flow',
  },
  {
    key: 'integration-guide-embedded-flow',
    label: 'View the Embedded Flow integration guide',
    path: '/dashboard/getting-started/embedded-flow',
    segmentPath: '/dashboard/getting-started/embedded-flow',
  },
  {
    key: 'integration-guide-mobile-sdks',
    label: 'View the Mobile SDKs integration guide',
    path: '/dashboard/getting-started/mobile-sdks',
    segmentPath: '/dashboard/getting-started/mobile-sdks',
  },
];
